import React from 'react';
import LocalizedStaticPage from './LocalizedStaticPage';

const About = () => <LocalizedStaticPage page="about" />;
export default About;
